
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, Council, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class CouncilListProvider implements Resolve<any> {
    council: Council[];
    councilEdit: Council;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.councilEdit = this.state?.currentCouncil;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
            if (!Object.entries(this.pageOptions.fieldSort)) {
                this.pageOptions.fieldSort = 'name';
            }
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<Council> {
        if (!id) {
            return null;
        }
        return this.gw.get('council/:id', { id: id });
    }

    get currentCouncil(): Council {
        return this.councilEdit;
    }

    getAll(entity?): Promise<any> {
        let urlPath = 'council/';
        if (entity) {
            urlPath = entity + urlPath;
        }
        return new Promise((resolve, reject) => {
            this.gw.get(urlPath).subscribe((res: HttpResponse<any>) => {
                this.council = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('council/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.council, res.body.content) && res.body.content.length > 0) {
                    this.council = res.body.content;
                    this.onDataChanged.next(this.council);
                }
                else {
                    this.council = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }

    findProperties() {

    }
}

